import React from 'react';
import '../styles/_financial_TCDI.scss';
import { useTranslation } from 'react-i18next';
import { HeaderTCDI } from '../../components/HeaderTCDI/HeaderTCDI';
import { CardInfo } from '../../../../Portfolio_R/SummaryCharts/components/CardInfo';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';
import FinancialAdvanceProgress from '../../components/FinancialAdvanceProgress/FinancialAdvanceProgress';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';
import PariPassuTable from '../../components/PariPassuTable/PariPassuTable';
import NomenclatureItem from '../../components/NomenclatureItem/NomenclatureItem';
import { dataProgress } from '../Common/NomenclatureItems';
import LinearProjectReport from '../../components/LinearProjectReport/LinearProjectReport';
import YearDisbursements from '../../components/YearDisbursements/YearDisbursements';
import { mapGeneralInfoInDataSource } from '../../utils/Helpers/MapperHelper';
import { formatDate } from '../../utils/Helpers/DataFormatHelper';
import { NoContentView } from '../../components/NoContentView/NoContentView';

export const FinancialTCDISection = ({ data }) => {
  const { t } = useTranslation();
  const { formatNumber } = useNumberFormatter();
  const dataSource = data.sectionTwoFinantialInformation;

  const {
    disbursement,
    finantialProgress,
    currentApprovedAmount,
    paripassu,
    advanceForComponent,
    disbursementAnnual
  } = dataSource;

  return (
    <div className='financial-tcdi-report'>
      <HeaderTCDI data={mapGeneralInfoInDataSource(data)} />
      <div className='financial-tcdi-info-report'>
        <h3 className='content-layout-title'>{t('info_financial')}</h3>
        <section className='financial-tcdi-info-layout'>
          <div className='tcdi-disbursements'>
            <h3 className="chart-title">{t('disbursements')}</h3>
            <div className="chart-content">
              <CardInfo
                title={t('gcm_no_disbursements_one_year')}
                data={formatDate(disbursement.lastDisbursementDate)} />
              <CardInfo
                title={t('min_justify_new_disbursement')}
                data={formatNumber(disbursement.minimumAmountToJustify)}
                units={t('dolar_sign')} />
            </div>
          </div>
          <div className='tcdi-financial-info'>
            <div className='tcdi-financial-info-header'>
              <h3 className='chart-title'>{t('one_pager_report.advance_per_component')}</h3>
              <NomenclatureItem data={dataProgress} />
            </div>
            {
              advanceForComponent.advanceComponent.length ? advanceForComponent.advanceComponent.slice(0,6)?.map(item => (
                <div key={item.id} className="component-advance-content">
                  <LinearProjectReport
                    title={item.nameComponent}
                    completed={item.justifiedPercent}
                    pending={item.pendingPercent}
                    initialAmount={'$ ' + formatNumber(item.justifiedAmount)}
                    pendingAmount={'$ ' + formatNumber(item.pendingAmount)} />
                </div>
              ))
              : <NoContentView title={t('last_no_information')} />
            }
          </div>
          <div className='tcdi-financial-advance'>
            <h3 className="chart-title">{t('one_pager_report.financial_advance')}</h3>
            <span className='chart-subtitle-focus'>{t('approved_current_amount')} {formatNumber(finantialProgress.totalDisbursementAmount)} {t('dolar_sign')}</span>
            <FinancialAdvanceProgress
              disbursmentAmount={finantialProgress.realizedDisbursementAmount}
              disbursment={finantialProgress.percentRealizedDisbursement}
              committedAmount={finantialProgress.commitedAmount}
              committed={finantialProgress.percentCommitedAmount}
              pendignAmount={finantialProgress.availableAmount}
              pending={finantialProgress.percentAvailableAmount} />
          </div>
          <div className='tcdi-current-approval-amount'>
            <h3 className="chart-title">{t('approved_current_amount')}</h3>
            <div className="chart-content">
              <CardInfo
                title={t('bid')}
                data={formatNumber(currentApprovedAmount.bidAmount)}
                units={t('dolar_sign')} />
              <CardInfo
                title={t('local_amount')}
                data={formatNumber(currentApprovedAmount.localAmount)}
                units={t('dolar_sign')} />
              <CardInfo
                title={capitalizeFirstLetter(t('cancelled_amount'))}
                data={formatNumber(currentApprovedAmount.cancelledAmount)}
                units={t('dolar_sign')} />
              <CardInfo
                title={capitalizeFirstLetter(t('reformulated_amount'))}
                data={formatNumber(currentApprovedAmount.adjustmentAmount)}
                units={t('dolar_sign')} />
            </div>
          </div>
          <div className='tcdi-year-disbursements'>
            <YearDisbursements chart={disbursementAnnual} />
          </div>
          <div className='tcdi-pari-passu'>
            <PariPassuTable
              deviationPercent={paripassu.pariPassuDeviationPercent}
              deviationAmount={paripassu.pariPassuDeviationAmount}
              contractualBIDAmount={paripassu.contractualBid}
              contractualLocalAmount={paripassu.contractualLocal}
              currentBIDAmount={paripassu.currentBID}
              currentLocalAmount={paripassu.currentLocal}
            />
          </div>
        </section>
      </div>
    </div>
  )
}
